import { DEFAULT_COVER_IMAGE, getImageSrcUrl } from "../../../common/utils/product-util";
import { ProductCardData } from "../../product-card/product-card-display";
import { WishListItem } from "../interfaces/wish-list-items.interface";
import { getWishListItemUrl } from "../utils/wish-list.util";

function getImage(item: WishListItem): string {
  if (item) {
    return getImageSrcUrl(item?.isbn13 || item?.isbn10);
  } else {
    return DEFAULT_COVER_IMAGE;
  }
}

function getGrade(minGrade: string, maxGrade: string): string {
  if (minGrade && maxGrade) {
    return `${minGrade}-${maxGrade}`;
  } else {
    return minGrade ? minGrade : maxGrade ? maxGrade : '';
  }
}

export function mapWishListItemToProductCardData(wishListItem: WishListItem, loggedInUserName?: string, store?: string): ProductCardData {
  return {
    kind: 'ProductCardData',
    title: wishListItem?.name,
    image: wishListItem.image_url ? wishListItem.image_url : getImage(wishListItem),
    url: getWishListItemUrl(wishListItem.isbn13 || wishListItem.isbn10),
    copyRightYear: wishListItem.copyright,
    store: store,
    mhid: wishListItem?.mhid,
    isbn: wishListItem?.isbn10,
    isbn13: wishListItem?.isbn13,
    netPrice: wishListItem?.net_price,
    totalPrice: Math.round(wishListItem.qty * (wishListItem?.list_price || 0) * 100) / 100,
    edition: +wishListItem?.edition,
    gradeLevels: getGrade(wishListItem.min_grade, wishListItem.max_grade),
    contributors: wishListItem?.authors?.map(author => `${author.given_name} ${author.family_name}`),
    instructorOnly: false,
    quantity: wishListItem?.qty,
    businessUnit: wishListItem?.business_unit,
    comments: wishListItem?.comments,
    userName: loggedInUserName ?? '',
  } as ProductCardData;
}